import React, { useState } from "react";
import { Eye, EyeOff, Receipt } from "lucide-react";
import "./goldDust.css";

const dustParticles = Array.from({ length: 80 });

export default function BillingLogin() {
  const [showPassword, setShowPassword] = useState(false);

  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Enter email and password");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        "/api/billing/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
  window.location.href = "/billingdashboard";
} else {
        alert(data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0b0b0f] via-[#12121a] to-[#0b0b0f]">

      {dustParticles.map((_, i) => (
        <span
          key={i}
          className="gold-dust"
          style={{
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 4 + 2}px`,
            height: `${Math.random() * 4 + 2}px`,
            animationDuration: `${Math.random() * 14 + 12}s`,
            animationDelay: `${Math.random() * 8}s`,
          }}
        />
      ))}

      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-80 h-80 bg-yellow-500/10 blur-[120px]" />
      <div className="absolute inset-0 luxury-pattern" />

      <div className="relative z-10 w-full max-w-lg">
        <div
          className="
            rounded-2xl
            bg-white/[0.03]
            backdrop-blur-[22px]
            border border-white/10
            px-8 py-10
            shadow-[0_40px_120px_rgba(0,0,0,0.8)]
          "
        >
          {/* HEADER */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-14 h-14 rounded-full bg-black/40 border border-white/10 flex items-center justify-center">
              <Receipt className="text-amber-400" size={22} />
            </div>

            <h1 className="mt-4 text-lg font-serif text-white tracking-wide">
              Billing Login
            </h1>

            <p className="mt-1 text-xs text-gray-400 text-center">
              Branch Counter Billing System
            </p>

            <div className="mt-3 w-10 h-[2px] bg-amber-400/70 rounded-full" />
          </div>

          {/* email */}
          <input
            type="text"
            placeholder="email"
            value={email}
            onChange={(e) => setemail(e.target.value)}
            className="
              w-full
              bg-transparent
              border border-white/15
              rounded-lg
              px-4 py-2.5
              text-sm text-white
              placeholder-gray-500
              focus:outline-none
              focus:border-amber-400
              transition
            "
          />

          {/* PASSWORD */}
          <div className="relative w-full mt-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="
                w-full
                bg-transparent
                border border-white/15
                rounded-lg
                px-4 py-2.5 pr-10
                text-sm text-white
                placeholder-gray-500
                focus:outline-none
                focus:border-amber-400
                transition
              "
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="
                absolute
                right-3
                top-1/2
                -translate-y-1/2
                text-gray-400
                hover:text-gray-200
              "
            >
              {showPassword ? (
                <EyeOff size={15} />
              ) : (
                <Eye size={15} />
              )}
            </button>
          </div>

          {/* LOGIN */}
          <button
            onClick={handleLogin}
            disabled={loading}
            className="
              mt-6
              w-full
              rounded-lg
              bg-gradient-to-r
              from-amber-400
              to-yellow-500
              py-2.5
              text-sm
              font-medium
              text-black
              hover:brightness-110
              transition
            "
          >
            {loading
              ? "Logging In..."
              : "Enter Billing System"}
          </button>

          <div className="mt-6 text-center text-[10px] text-gray-500">
            Cashier / Counter Manager Access Only
          </div>
        </div>
      </div>
    </div>
  );
}